import { InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { useLoginRedirectStore } from '@/features/auth/stores/login-redirect-store'

const PostLoginRedirect = () => {
  const [destination] = useState(() =>
    useLoginRedirectStore.getState().fetchRedirectDestination()
  )

  return <Navigate to={destination || '/'} replace />
}

export const UnauthenticatedRoute = () => {
  const { inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  if (inProgress !== InteractionStatus.None) {
    return null
  }

  if (isAuthenticated) {
    return <PostLoginRedirect />
  }

  return <Outlet />
}
